import 'babel-polyfill';
import VueClipBoard from 'vue-clipboard2';

import 'normalize.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss';

import Vue from 'vue';
import ElementUI from 'element-ui';
import moment from 'moment';
import Vue2Filters from 'vue2-filters';

import App from './App.vue';
import Components from './components';
import utils from './utils';
import Filters from './filter';
import mixin from './mixin';
import router from './router';
import store from './store';

import './icons';
import './auth';
import './utils/errorHandler';
import tgp from './utils/tgp/index';
// vue2-filters配置
const vue2FiltersConfig = {
    number: {
        format: '0,0.00',
        thousandsSeparator: ',',
        decimalSeparator: '.'
    },
    currency: {
        symbol: '¥',
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: false,
        decimalDigits: 2,
        thousandsSeparator: ',',
        decimalSeparator: '.',
        showPlusSign: false
    }
};

// 注册全局组件和过滤器
Vue.use(ElementUI, { size: 'small' });
Vue.use(Vue2Filters, vue2FiltersConfig);
Vue.use(Filters);
Vue.use(Components);
Vue.use(VueClipBoard);
// 将常用函数注入到vue原型上
Vue.prototype.$moment = moment;
Vue.prototype.$utils = utils;

Vue.mixin(mixin);

const app = new Vue({
    router,
    store,
    render: h => h(App)
});

app.$mount('#app');
